<template>
  <div class="trainer-edit">
    <loader v-if="editingTrainer"></loader>
    <div
      class="d-flex flex-column flex-fill justify-content-center align-items-center"
    >
      <div class="edit mt-5">
        <form v-if="trainerData">
          <b-form-group>
            <label class="mb-0 form__label-tp">Name</label>
            <b-form-input
              v-model="trainerData.name"
              required
              size="sm"
              trim
              maxlength="50"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label class="mb-0 form__label-tp">Description</label>

            <b-form-textarea
              v-model="trainerData.description"
              required
              size="sm"
              trim
              rows="5"
              maxlength="1000"
              placeholder="Your description will appear here..."
            ></b-form-textarea>
          </b-form-group>
          <b-form-group style="height: 60px">
            <b-row>
              <b-col>
                <label class="mb-0 form__label-tp"
                  >Profile Photo (100*100px)</label
                >
              </b-col>
            </b-row>
            <div>
              <b-row>
                <b-col cols="9">
                  <b-form-input
                    v-model="trainerData.profilePicUrl"
                    required
                    size="sm"
                    trim
                    disabled
                    maxlength="50"
                  ></b-form-input>
                </b-col>
                <b-col cols="3">
                  <b-button
                    size="sm"
                    class="custom-button select"
                    @click="
                      $refs.profilePic.$el
                        .querySelector('input[type=file]')
                        .click()
                    "
                  >
                    <p>SELECT</p>
                  </b-button>
                </b-col>
              </b-row>
            </div>
            <b-form-file
              class="form___file"
              v-model="profilePic"
              ref="profilePic"
              :state="Boolean(profilePic)"
              placeholder="Select Files"
              size="sm"
              accept="image/*"
              @change="handleImageChange($event)"
            ></b-form-file>
          </b-form-group>
          <b-form-group style="height: 60px">
            <b-row>
              <b-col cols="9">
                <label class="mb-0 form__label-tp">Upload Cover Video</label>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="1">
                <b-form-radio style="margin-top: 4px;" v-model="selected" name="some-radios" value="s3Video"></b-form-radio>
              </b-col>
              <b-col cols="8">
                <b-form-input
                  v-model="trainerData.coverVideoURL"
                  v-bind:class="{videoInput: selected!='s3Video'}"
                  required
                  size="sm"
                  trim
                  disabled
                  maxlength="50"
                ></b-form-input>
              </b-col>
              <b-col cols="3">
                <b-button
                  :disabled="selected != 's3Video'"
                  size="sm"
                  class="custom-button select"
                  @click="
                    $refs.coverVideoInput.$el
                      .querySelector('input[type=file]')
                      .click()
                  "
                >
                  <p>SELECT</p>
                </b-button>
              </b-col>
            </b-row>
            <b-form-file
              class="form___file"
              ref="coverVideoInput"
              v-model="trainerProfileInfo.coverVideo"
              :state="Boolean(coverVideo)"
              placeholder="Select Files"
              size="sm"
              accept="video/*"
              @change="handleVideoChange($event)"
            ></b-form-file>
          </b-form-group>
          <b-form-group>
            <b-row>
              <b-col cols="9">
                <label class="mb-0 form__label-tp"
                  >Upload YouTube Cover Video</label
                >
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="1">
                <b-form-radio style="margin-top: 4px;" v-model="selected" name="some-radios" value="youTubeLink"></b-form-radio>
              </b-col>
              <b-col cols="8">
                <b-form-input
                  class="videoInput"
                  v-model="trainerData.coverYTurl"
                  required
                  size="sm"
                  trim
                  maxlength="100"
                  :disabled="selected != 'youTubeLink'"
                ></b-form-input>
              </b-col>
            </b-row>
          </b-form-group>
          <div class="custom-button save" @click="editTrainer">
            <p>SAVE CHANGES</p>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
import EmbedID from "@/utils/youtubeEmbedID.js";
const { mapActions: s3Actions } = createNamespacedHelpers("admin/videosView");
const { mapActions, mapGetters } = createNamespacedHelpers(
  "admin/trainerProfileEdit"
);

import S3Url from "../s3upload/getSignedURL.js";
import toast from "../toaster.js";

export default {
  data: function () {
    return {
      profilePic: null,
      coverVideo: null,
      profilePicURL: null,
      coverVideoURL: null,
      editingTrainer: false,
      profilePicChanged: false,
      coverVideoChanged: false,
      trainerProfileInfo: {},
      fullProfileURL: null,
      fullVideoURL: null,
      selected: null
    };
  },

  methods: {
    ...s3Actions(["getS3Cred"]),
    ...mapActions(["updateTrainer", "loadTrainerProfile"]),

    handleImageChange(e) {
      this.createBase64Img(e.target.files[0]);
    },

    createBase64Img(file) {
      this.profilePicChanged = true;
      this.trainerData.profilePicUrl = file.name;
      this.thumbnailFile = file;
      const reader = new FileReader();

      reader.onload = (e) => {
        this.thumbnail = e.target.result;
        this.thumbnailSrc =
          "data:image/jpeg;base64," +
          btoa(
            new Uint8Array(this.thumbnail).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            )
          );
      };
      reader.readAsArrayBuffer(file);
    },

    handleVideoChange(e) {
      this.coverVideoChanged = true;
      const reader = new FileReader();
      this.coverFile = e.target.files[0];
      this.trainerData.coverVideoURL = this.coverFile.name;
      reader.onload = (e) => {
        this.coverFileContent = e.target.result;
      };
      reader.readAsArrayBuffer(this.coverFile);
    },

    async editTrainer() {
      this.editingTrainer = true;
      await this.getS3Cred();
      let s3Cred = this.$store.state.admin.videosView.s3Cred;
      //upload thumbnail to s3
      if (this.profilePicChanged) {
        let thumbResponse = await S3Url.getS3Url(
          s3Cred,
          this.thumbnailFile,
          this.thumbnail,
          "thumbnails"
        );
        this.trainerData.fullProfileURL = thumbResponse.Location;
        this.profilePicChanged = false;
      } else {
        this.trainerData.fullProfileURL = this.fullProfileURL;
      }

      if (this.selected=="s3Video") {
        if (this.coverVideoChanged) {
          //upload video to s3
          let response = await S3Url.getS3Url(
            s3Cred,
            this.coverFile,
            this.coverFileContent,
            "videos"
          );
          this.trainerData.fullVideoURL = response.Location;
          this.coverVideoChanged = false;
          this.trainerData.coverVideoEmbed = null;
        } else {
          this.trainerData.fullVideoURL = this.fullVideoURL;
          this.trainerData.coverVideoEmbed = null;
        }
      }
      else if (this.selected=="youTubeLink") {
        this.trainerData.coverVideoEmbed = EmbedID.getEmbedID(this.trainerData.coverYTurl)
        this.trainerData.fullVideoURL = null
      }
      await this.updateTrainer({ vm: this, data: this.trainerData });
      this.loadTrainerProfile();
      this.editingTrainer = false;
    },
  },

  computed: {
    ...mapGetters(["trainerProfileData"]),

    trainerData() {
      if (this.trainerProfileData) {
        this.fullProfileURL = this.trainerProfileData.profilePicUrl;
        let coverUrl = "";
        let coverYTurl = "";
        if (this.trainerProfileData.coverVideoUrl) {
          this.fullVideoURL = this.trainerProfileData.coverVideoUrl
          coverUrl = this.trainerProfileData.coverVideoUrl.substr(
            this.trainerProfileData.coverVideoUrl.indexOf("/videos/") +
              "/videos/".length
          );
          this.selected = "s3Video"
        } else if (this.trainerProfileData.coverVideoEmbed) {
          coverYTurl =
            "https://www.youtube.com/watch?v=" +
            this.trainerProfileData.coverVideoEmbed;
          this.selected = "youTubeLink"
        }
        let profilURL = "";
        if (this.trainerProfileData.profilePicUrl) {
          profilURL = this.trainerProfileData.profilePicUrl.substr(
            this.trainerProfileData.profilePicUrl.indexOf("/thumbnails/") +
              "/thumbnails/".length
          );
        }
        let data = {
          name: this.trainerProfileData.Name,
          description: this.trainerProfileData.description,
          profilePicUrl: profilURL,
          coverVideoURL: coverUrl,
          coverYTurl: coverYTurl
        };
        return data;
      }
    },
  },
  async mounted() {
    await this.loadTrainerProfile();
  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === "setSelectedTenant") {
        this.loadTrainerProfile();
      }
    });
  },

  beforeDestroy() {
    this.unsubscribe();
  },
};
</script>
<style lang="scss" scoped>
input,
input:focus,
textarea,
textarea:focus,
input:disabled {
  background: transparent;
  color: #fff;
}
.videoInput:disabled {
  background-color: grey;
}
button:disabled{
  cursor: auto;
  pointer-events: none;
}
.form-control::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #fff;
}
.trainer-edit {
  background: #5c6567;
  font-family: Kanit-Regular, Kanit;
}
.form__label-tp {
  color: #bcbec0 !important;
  font-size: 18px;
  font-family: Kanit-Regular, Kanit;
  width: 100% !important;
}
.select {
  width: 100px;
  background: #73bc44;
  color: #231f20;
}
.edit {
  width: 50%;
}
.form___file {
  opacity: 0;
  height: 100% !important;
  width: 100%;
  position: relative;
}
.save {
  background: transparent;
}
.profile-img {
  height: 80px;
  width: 80px;
}
.custom-button:hover {
  background-color: #73bc44;
}
</style>